import { ChangeDetectorRef, Component, EventEmitter, Input, Output, inject, signal } from '@angular/core';
import { FoldseekService } from '../foldseek.service';
import { DownloadService } from 'src/app/download-service';
import { GoogleAnalyticsService } from 'src/app/google-analytics.service';
import { ConfigService } from 'src/app/config.service';
import { CheckboxService } from '../checkbox.service';
import { Subscription } from 'rxjs';
import { FoldseekapiService } from '../foldseekapi.service';
import { MatTableDataSource } from '@angular/material/table';
import { SimilarStructure } from 'src/app/entry/structure-data.models';

@Component({
  selector: 'app-pdb-tab',
  templateUrl: './pdb-tab.component.html',
  styleUrl: './pdb-tab.component.css',
  standalone: false
})
export class PdbTabComponent {
  @Input() accession: boolean;
  @Input() afdb_accession: boolean;
  
  // @Output() toggleClickedEvent = new EventEmitter<any>();
  @Output() toggleClickedEvent: EventEmitter<Object> = new EventEmitter();

  private subscription: Subscription;
  checkboxState: { [key: string]: boolean } = {};
  disabledState: { [key: string]: boolean } = {};

  public downloadService = inject(DownloadService);
  public foldseekService = inject(FoldseekService);
  public foldseekapiService = inject(FoldseekapiService);
  
  filteritemPDB = this.foldseekapiService.filteritemPDB();

  checked = false;
  disabled = false;
  superposeData = [];

  displayedColumnsStructureWithExpand: string[] = ['expand',  'select', 'afdbAccessions', 'descriptions', 'speciesNames','sequenceLength', 'evalue', 'sequenceIdentity', 'resolution', 'alighin3D'];
  pdbStructureDataSource =  signal<any>(new MatTableDataSource<SimilarStructure>());

  selectedValuesPDB = this.downloadService.selectedValuesPDB;
  allSelectedPDB = this.downloadService.allSelectedPDB;
  selectionPDB = signal<any>(new Set<string>());

  constructor(
    public gaService: GoogleAnalyticsService,
    private configService: ConfigService,
    private changeDetectorRef: ChangeDetectorRef,
    private checkboxService: CheckboxService) { }

  dropdownOptionsPDB: { label: string, value: any, isShow: boolean, disabled?: boolean, info?: string }[];

  ngOnInit(): void {
    this.downloadService.updateSelectedValuePDB([]);
    this.subscription = this.checkboxService.checkboxState$.subscribe(state => {
      this.checkboxState = state;
      this.changeDetectorRef.detectChanges(); // Trigger change detection manually
    });

    this.checkboxService.disabledState$.subscribe(state => {
      this.disabledState = state;
    });

    this.dropdownOptionsPDB = [
      { label: 'Search results (max 10 000)', value: "allresultscsv" , isShow: true, disabled: false},
      { label: 'Coordinates and validation data (max 100)', value: "modelcoordicate", isShow: true, disabled: true},
    ];

    this.foldseekapiService.checkAndGetStructureData(this.foldseekapiService.recordsPDB(), this.foldseekapiService.startPDB(), this.foldseekapiService.sort_direction_PDB(), this.foldseekapiService.sort_column_PDB(), this.foldseekapiService.species_name_filter_PDB());
  }

  ngAfterViewInit(): void {
    this.changeDetectorRef.detectChanges();
  }
  clickToggleSuperpose(event, accession){
    this.toggleClickedEvent.emit({event, accession})
  }
  expandedElement
  expandRow(element) {
    this.expandedElement = this.expandedElement === element ? null : element
  }
  
  expandedElements = [];
  toggleRowPDB(element) {
    this.gaService.eventEmitter(
      'foldseek_expand_seq', 'FS_similar_structures', 'click', 'foldseek_expand_sequence', 'Clicks on the expand row triangle to see sequence alignment on the Foldseek results table'
    );
    const ele = this.expandedElements.find(e => e.afdbAccessions === element.afdbAccessions);
    if(ele){
      this.expandedElements = this.expandedElements.filter(el => el.afdbAccessions !== element.afdbAccessions)
    } else {
      this.expandedElements.push(element)
    }
  }
  
  isExpanded(element): boolean {
    const ele = this.expandedElements.find(e => e.afdbAccessions === element.afdbAccessions);
    return ele ? true : false;
  }

  isExpansionDetailRow = (i: number, row) => this.isExpanded(row);
}
